<template>
  <div>
    <div class="contact_title py-7.5">
      <h2>{{ title }}</h2>
      <p></p>
    </div>

    <el-collapse v-model="activeName" accordion>
      <el-collapse-item :title="l.question" :name="index" v-for="(l, index) in list" :key="index">
        <div class="pt-5">
          {{ l.answer }}
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  props: {
    title: {
      type: String,
      default: null
    },
    list: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      activeName: '0'
    };
  }
};
</script>
